import { defineStore } from 'pinia'

interface LuckyNumber {
  luckyNumber: string
  lastResetDate: number
}
const STORE_NAME = 'luckyNumber'

export const useLuckyNumberStore = defineStore(STORE_NAME, {
  state: (): LuckyNumber => ({
    luckyNumber: '',
    lastResetDate: 0
  }),
  persist: true,
  actions: {
    setLastResetDate(value: number) {
      this.lastResetDate = value
    },
    getLastResetDate(): number {
      return this.lastResetDate
    },
    setLuckyNumber(data: string): void {
      this.luckyNumber = data
    },
    getLuckyNumber(): string {
      return this.luckyNumber
    }
  }
})
